import React from 'react';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import i18n from 'i18next';
var t = i18n.getFixedT(null, 'app');

var AuditLogErrorMessage = function AuditLogErrorMessage() {
  return /*#__PURE__*/React.createElement("div", {
    id: "g-audit-log-error-message"
  }, /*#__PURE__*/React.createElement(PriorityHighIcon, null), t('global.lbl-audit-log-error-message'));
};

export default AuditLogErrorMessage;